import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import api from "../../api";
import { PageTitle, TH, TD, Badge } from "./AdminLayout";
import { Switch } from "../../components/ui/switch";

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get(`/admin/discord-users${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setUsers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const patch = async (u, body) => {
    try {
      await api.patch(`/admin/discord-users/${u.id}`, body);
      toast.success(`Updated ${u.username}`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div data-testid="admin-users">
      <PageTitle title="User Management" sub="Discord users interacting with GrooveMusic (sample data)." />
      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative max-w-sm mb-6">
        <Search size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search users…" data-testid="users-search"
          className="w-full bg-white/5 border border-white/10 rounded-full pl-10 pr-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blurple" />
      </form>

      <div className="rounded-lg border border-white/5 bg-panel overflow-x-auto">
        <table className="w-full min-w-[820px]" data-testid="users-table">
          <thead className="border-b border-white/5"><tr><TH>User</TH><TH>Servers</TH><TH>Commands</TH><TH>Songs played</TH><TH>Last active</TH><TH>Banned</TH><TH>Restricted</TH></tr></thead>
          <tbody className="divide-y divide-white/5">
            {users.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.username.replace(/[^a-z0-9]+/gi, "-")}`}>
                <TD>
                  <span className="font-semibold text-white">{u.username}</span>
                  {u.banned && <span className="ml-2"><Badge tone="red">banned</Badge></span>}
                  {u.restricted && <span className="ml-2"><Badge tone="amber">restricted</Badge></span>}
                </TD>
                <TD className="font-mono">{u.servers}</TD>
                <TD className="font-mono">{u.commands_used.toLocaleString()}</TD>
                <TD className="font-mono">{u.songs_played.toLocaleString()}</TD>
                <TD className="text-white/50 text-xs font-mono">{new Date(u.last_active).toLocaleDateString()}</TD>
                <TD><Switch checked={u.banned} onCheckedChange={(v) => patch(u, { banned: v })} data-testid={`user-ban-${u.id}`} /></TD>
                <TD><Switch checked={u.restricted} onCheckedChange={(v) => patch(u, { restricted: v })} data-testid={`user-restrict-${u.id}`} /></TD>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
